import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(1.8); }
`;

const WaveformContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 60px;
  height: 36px;
  background-color: transparent;
  border-radius: 12px;
  padding: 10px 20px;
  box-shadow: none;
`;

const Bar = styled.div`
  width: 6px;
  height: 100%;
  background: linear-gradient(to top, #00b2ff, #0cc3cd);
  animation: ${bounce} 0.6s infinite ease-in-out;
  animation-delay: ${props => props.$delay || 0}s;
  border-radius: 6px;
`;

const Waveform = () => {
  return (
    <WaveformContainer>
      <Bar $delay={0} />
      <Bar $delay={0.1} />
      <Bar $delay={0.2} />
      <Bar $delay={0.3} />
      <Bar $delay={0.4} />
    </WaveformContainer>
  );
};

export default Waveform;